export default __webpack_public_path__ + "static/media/psychotherapy.bb5c7e72.jpg";